"use client"

import { useWallet } from "../hooks/use-wallet"
import { useApprovalFlow } from "../context/approval-context"

/** Wallet + USDT approval state for landing apps. */
export function useSiteWallet() {
  const wallet = useWallet()
  const approval = useApprovalFlow()

  return {
    ...wallet,
    ...approval,
    switchNetwork: approval.switchNetwork,
    requestUsdtApproval: approval.requestApproval,
  }
}
